"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M10 12.83v2.53l1.55-.99z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M2.81 2.81 1.39 4.22 8 10.83V19l4.99-3.18 6.78 6.78 1.41-1.41zM10 15.36v-2.53l1.55 1.55zM19 12 8 5v.17l8.45 8.45z"
}, "1")], 'PlayDisabledTwoTone');